import { mapState, mapGetters } from 'vuex';
import API from '../../api';

export default {
	data() {
		return {
			formData: {},
            complete: false,
		}
	},
	computed: {
		...mapState({
			id: state => state.form.id,
			currentStep: state => state.form.currentStep,
			totalSteps: state => state.form.totalSteps,
		}),
		...mapGetters({
			savedFormData: 'form/formData'
		})
	},
	methods: {
		submit() {
            return this.$validator.validateAll().then((result) => {
                // console.log("Current Step: ", this.currentStep, " Total Steps: ", this.totalSteps, " Result: ", result);
                if(!result || this.$wait.is('submit')) {
                    return;
                }

                this.$wait.start('submit');
                let hasErrors = false;

                let save = this.save();

                return save.then((response) => {
                    // console.log("Save Response: ", response);
                    this.$store.commit('form/mergeFormData', this.formData);
                    this.$store.commit('form/completeCurrentStep', this.formData);

                    return response;
                })
                    .catch(error => {
                        API.mapServerValidation(error.response, this.$validator);
                        hasErrors = true;
                    })
                    .finally(() => {
                        this.$wait.end('submit');

                        if(!hasErrors && this.currentStep !== this.totalSteps) {
                            if(this.currentStep < this.totalSteps) {
                                this.$store.commit('form/nextStep');
                            }
                        } else {
                            if(!this.complete && !hasErrors && this.currentStep === this.totalSteps) {
                                this.complete = true;
                                this.sendToPreview();
                            }
                        }
                    });
            });
		},
		save() {
			return Promise.reject('Not implemented');
		},
		sendToPreview() {
			this.save().then(() => Promise.reject('Not implemented'));
		},
		back() {
			this.$store.commit('form/previousStep');
		},
		updateFormData() {
			let data = this.savedFormData;

			Object.keys(this.formData).map( key => {
				if(data[key] === undefined) {
					return;
				}

                this.formData = {
                    ...this.formData,
                    [key]: data[key],
                }
			});
		}
	},
	created() {
		this.updateFormData();

		this.$store.subscribe((mutation, state) => {
			if(mutation.type === 'form/mergeFormData' || mutation.type === 'form/setFormData' ){
				this.updateFormData();
			}
		})
	},
}
